import { useEffect, useState } from "react";
import { eventsSessionStorage } from "services/storage/events";

const useCurrentTabOfEventList = ({ isTeacherUser, tabDataValues }) => {
	const [currentTabIdx, setCurrentTabIdx] = useState(-1);
	const [claimsAboutCurrentTab, setClaimsAboutCurrentTab] = useState({
		isPast: false,
		isDraft: false,
		isCancelled: false,
		isUnprocessed: false
	});
	useEffect(() => {
		initCurrentTabIdx();
	}, []);
	useEffect(() => {
		setClaimsAboutCurrentTab({
			isPast: currentTabIdx === tabDataValues.PAST,
			isDraft: currentTabIdx === tabDataValues.DRAFT,
			isCancelled: currentTabIdx === tabDataValues.CANCELED,
			isUnprocessed: currentTabIdx === tabDataValues.UNPROCESSED
		});
	}, [currentTabIdx]);
	const initCurrentTabIdx = () => {
		if (isTeacherUser) {
			setCurrentTabIdx(0);
			return;
		}
		const tabIdx = eventsSessionStorage.currentTabIdxEventList.get();
		if (isSomeTab(tabIdx)) {
			setCurrentTabIdx(tabIdx);
			return;
		}
		setCurrentTabIdx(0);
	};
	const isSomeTab = tabIdx => Object.values(tabDataValues).includes(tabIdx);
	return {
		index: currentTabIdx,
		setIndex: setCurrentTabIdx,
		claims: claimsAboutCurrentTab,
		isSomeTab: () => isSomeTab(currentTabIdx),
	};
};

export default useCurrentTabOfEventList;
